module.exports = __webpack_public_path__ + "static/media/S2N7-4.a3240ca1.svg";